import type { ChangeEvent } from 'react';
import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { Select } from '@motorway/motorway-storybook-cra';

import useAccountRouter from 'Components/Account/useAccountRouter';
import { triggerCompletePurchasesStatusFilter } from 'Services/analytics/events';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from './AccountPurchaseCompleteStatusFilter.texts.json';

import styles from './AccountPurchaseCompleteStatusFilter.module.scss';

const LocalT = new MDText(LocalTexts);

interface AccountPurchaseCompleteStatusFilterProps {
	cypressDataId?: string;
	label?: string;
	selectClassName?: string;
}

const AccountPurchaseCompleteStatusFilter: React.FC<AccountPurchaseCompleteStatusFilterProps> = ({
	cypressDataId,
	label,
	selectClassName,
}) => {
	const { purchasesCompleteStatusType } = useAccountRouter();
	const { changePage } = useAccountRouter();

	const onChangeHandler = ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
		changePage({ purchasesCompleteStatusType: value });
		triggerCompletePurchasesStatusFilter(value);
	};

	return (
		<Select
			className={cx(styles.AccountPurchaseCompleteStatusFilter, selectClassName)}
			id="AccountPurchaseCompleteStatusFilter"
			label={label}
			selectProps={{
				...applyCypressData(cypressDataId),
				onChange: onChangeHandler,
			}}
			value={purchasesCompleteStatusType}
		>
			{Object.values(PurchasesCompleteStatusTypes).map((status) => (
				<option key={status} value={status}>
					{LocalT.translate(`filterOptions.${status}`)}
				</option>
			))}
		</Select>
	);
};

export default AccountPurchaseCompleteStatusFilter;
